import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import "./style.css";

export default function HeaderEditModal({ show, onClose, row, onSaved }) {
    const [title, setTitle] = useState(row?.title || "");
    const [focus, setFocus] = useState(row?.focus_position || "center");
    const [preview, setPreview] = useState(row?.image_url || "");
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (row) {
            setTitle(row.title || "");
            setFocus(row.focus_position || "center");
            setPreview(row.image_url || "");
            setFile(null);
        }
    }, [row]);

    const handleFileChange = (e) => {
        const f = e.target.files[0];
        if (!f) return;
        setFile(f);
        const reader = new FileReader();
        reader.onload = (ev) => setPreview(ev.target.result);
        reader.readAsDataURL(f);
    };

    const handleSubmit = async () => {
        if (!title.trim()) {
            Swal.fire("Peringatan", "Judul tidak boleh kosong.", "warning");
            return;
        }

        try {
            setLoading(true);
            const form = new FormData();
            form.append("title", title);
            form.append("focus_position", focus);
            form.append("active", row.active ?? 1);
            if (file) form.append("image", file);

            await axios.put(`${process.env.REACT_APP_API_URL}/header/${row.id}`, form, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            Swal.fire({
                icon: "success",
                title: "Tersimpan",
                timer: 1200,
                showConfirmButton: false,
            });
            onSaved();
            onClose();
        } catch (err) {
            console.error(err);
            Swal.fire("Gagal", "Tidak dapat menyimpan perubahan.", "error");
        } finally {
            setLoading(false);
        }
    };

    if (!show) return null;

    return (
        <div
            className="modal fade show"
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "rgba(0,0,0,0.6)",
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                zIndex: 1050,
            }}
        >
            <div
                className="modal-dialog"
                style={{
                    width: "95vw",
                    maxWidth: "1600px",
                    margin: "0 auto",
                    height: "90vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <div
                    className="modal-content"
                    style={{
                        width: "100%",
                        height: "100%",
                        borderRadius: 10,
                        boxShadow: "0 10px 40px rgba(0,0,0,0.25)",
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    {/* BODY */}
                    <div
                        className="modal-body"
                        style={{
                            flex: 1,
                            overflowY: "auto",
                            padding: "2rem 3rem",
                            background: "#fff",
                        }}
                    >
                        <div className="form-group">
                            <label>Judul</label>
                            <input
                                type="text"
                                className="form-control"
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                                placeholder="Masukkan judul..."
                            />
                        </div>

                        <div className="form-group mt-4">
                            <label>Pratinjau</label>
                            <div
                                style={{
                                    width: "100%",
                                    height: 380,
                                    borderRadius: 10,
                                    border: "1px solid #e5e7eb",
                                    background: preview
                                        ? `url('${preview}') ${focus} / cover no-repeat`
                                        : "#f3f4f6",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "#9ca3af",
                                }}
                            >
                                {preview ? "" : "Belum ada gambar"}
                            </div>
                            {preview && (
                                <button
                                    className="btn btn-sm btn-outline-secondary mt-2"
                                    onClick={() =>
                                        Swal.fire({
                                            title: "Pratinjau Ukuran Header",
                                            html: `
                                                <div style="width:100%;min-height:60vh;border-radius:10px;
                                                background:url('${preview}') center / cover no-repeat;"></div>
                                            `,
                                            showConfirmButton: false,
                                            width: "90%",
                                        })
                                    }
                                >
                                    Lihat Penuh
                                </button>
                            )}
                        </div>

                        <div className="form-group mt-4">
                            <label>Ganti Gambar (opsional)</label>
                            <input
                                type="file"
                                accept="image/*"
                                className="form-control-file"
                                onChange={handleFileChange}
                            />
                        </div>

                    </div>

                    {/* FOOTER */}
                    <div
                        className="modal-footer bg-light"
                        style={{
                            borderBottomLeftRadius: 16,
                            borderBottomRightRadius: 16,
                            padding: "1rem 2rem",
                        }}
                    >
                        <button className="btn btn-secondary" onClick={onClose} disabled={loading}>
                            Batal
                        </button>
                        <button
                            className="btn btn-primary"
                            onClick={handleSubmit}
                            disabled={loading}
                        >
                            {loading ? "Menyimpan..." : "Simpan"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
